import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type BannerCategoryFragment = { id: string, pk: number, created: any, sortOrder: number, name: string };

export const BannerCategoryFragmentDoc = gql`
    fragment BannerCategoryFragment on BannerCategoryType {
  id
  pk
  created
  sortOrder
  name
}
    `;